export default __webpack_public_path__ + "ce6d085d5ff2325dfbebc3c6995692aa.png";